import React from 'react';
import './Cases.css';
import CaseCard from '../UI/CaseCard/CaseCard';
import { caseData } from '../../assets/data/casesData';
import AniStatistic from '../AniStatistic/AniStatistic';
import { useTranslation } from 'react-i18next';

const Cases = ({ title }) => {
  const { t } = useTranslation();

  return (
    <section className="cases">
      <div className="cases__container container">
        {title !== false && (
          <h2 className="cases__title main-title">{title || t('cases')}</h2>
        )}
        <div className="cases__wrapper">
          <div className="cases__cards">
            {caseData(t).map((card, index) => (
              <CaseCard
                key={index}
                title={card.title}
                image={card.image}
                description={card.description}
                link={card.link}
              />
            ))}
          </div>
          <AniStatistic />
        </div>
      </div>
    </section>
  );
};

export default Cases;
